
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovaperkmrateforoutstation() {



    const cardData =
    {
        keyword: 'Pune to Outstation Cab',
        heading: 'Prince Cabs: Innova Per Km Rate for Outstation',
        headingDescription: 'Prince Cabs offers affordable Innova Per Km Rate for Outstation travel, perfect for family tours, corporate trips, pilgrimages, and long-distance journeys. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities to ensure a safe and comfortable ride. With transparent per km pricing, professional drivers, and flexible travel plans, we make your outstation trips economical and hassle-free. Experience reliability, comfort, and value with Prince Cabs’ trusted Innova outstation cab service at the best per km rates.',

        top: 'Top Places to Visit in Pune Outstation with Prince Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is one of Maharashtra’s most loved hill stations. Famous for its strawberry farms, boating at Venna Lake, and viewpoints like Arthur’s Seat and Wilson Point, it offers a refreshing escape from city life. The ancient Mahabaleshwar Temple adds spiritual significance. During monsoon, waterfalls and misty valleys make it magical. Winters bring a cozy holiday feel. It is among the top weekend getaways from Pune."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations in the Sahyadris, ideal for quick trips. They are known for attractions like Tiger’s Leap, Bhushi Dam, Karla & Bhaja Caves, and Rajmachi Fort. Monsoon transforms the valleys into green carpets dotted with waterfalls. Adventure lovers enjoy trekking, camping, and Pawna Lake activities. Street food like hot vada pav and chikki adds local flavor. They remain Pune’s favorite weekend getaways."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, a planned hill city about 60 km from Pune, is inspired by Italian architecture and built around a serene lake. The Lakeside Promenade is lined with cafés, resorts, and vibrant streets. Boating, cycling, and adventure sports make it ideal for families and couples. The cityscape looks particularly scenic in monsoon. Wellness retreats here attract urban travelers. Lavasa blends modernity, leisure, and natural beauty."
  },
  {
    "title": "Panchgani",
    "description": "Located 100 km from Pune, Panchgani is a peaceful hill station surrounded by five hills. Table Land, Asia’s second-largest volcanic plateau, is its highlight. Strawberry farms, viewpoints, and boarding school heritage add charm. Paragliding and trekking attract adventure seekers. Its calm weather makes it a year-round destination. Panchgani is often visited along with Mahabaleshwar for a complete hill retreat."
  },
  {
    "title": "Matheran",
    "description": "Matheran, about 120 km from Pune, is Asia’s only automobile-free hill station. Known for its red-soil trails, toy train, and 30+ viewpoints like Panorama Point and Charlotte Lake, it is perfect for nature lovers. Trekkers enjoy its forested routes, especially in monsoon. The fresh air and eco-friendly vibe make it unique. Families and couples love its peaceful charm. It offers a vintage hill-station experience."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, around 140 km from Pune, is a coastal getaway famous for its beaches and sea forts. Popular spots include Alibaug Beach, Varsoli Beach, and Kolaba Fort. Adventure lovers enjoy water sports at Nagaon Beach. The town is also famous for fresh seafood and beach homestays. Sunset views over the Arabian Sea are spectacular. Alibaug is the perfect mix of history, leisure, and sea breeze."
  },
  {
    "title": "Tarkarli",
    "description": "Tarkarli, in Sindhudurg district, is about 385 km from Pune and worth the long drive for its pristine beaches. Known as Maharashtra’s scuba diving capital, it offers snorkeling, parasailing, and dolphin-spotting. The white sands and clear waters rival Goa’s charm. Homestays near the beach showcase Konkani hospitality. Sindhudurg Fort nearby adds historical value. It is a paradise for water sports and nature lovers."
  },
  {
    "title": "Shirdi",
    "description": "Located 185 km from Pune, Shirdi is one of India’s most important pilgrimage centers dedicated to Shri Sai Baba. Devotees visit the Samadhi Mandir, Dwarkamai, and Chavadi for blessings. The daily aartis attract lakhs of pilgrims. The town is well connected by road, making it a convenient outstation trip. Many combine Shirdi with Shani Shingnapur for a spiritual circuit. Shirdi is a soulful retreat for faith and devotion."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a city of temples, vineyards, and riverside ghats. The Trimbakeshwar Temple, one of the 12 Jyotirlingas, is a major spiritual attraction. Panchavati, Sita Gufa, and Ramkund connect it to the Ramayana. Sula Vineyards and wineries make it India’s wine capital. Nashik also hosts the Kumbh Mela every 12 years, attracting millions. It is a balanced mix of spirituality and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, about 230 km from Pune, is famous for the Mahalaxmi Temple, a Shakti Peetha of immense religious importance. Visitors also explore Rankala Lake, Panhala Fort, and Jyotiba Temple. Kolhapur is equally renowned for spicy Kolhapuri cuisine and traditional chappals. Its blend of devotion, culture, and shopping makes it a fulfilling trip. Festivals like Navratri and fairs attract large crowds. Kolhapur is a complete cultural experience."
  },
  {
    "title": "Satara (Kaas Plateau)",
    "description": "Satara, about 110 km from Pune, is famous for the Kaas Plateau, a UNESCO World Heritage Site. During monsoon, the plateau blooms with rare flowers, earning it the name ‘Valley of Flowers of Maharashtra.’ Sajjangad Fort and Thoseghar Waterfalls add to its charm. Trekkers and photographers love its natural beauty. The scenic landscapes are best enjoyed between August and October. Satara is a monsoon paradise for nature enthusiasts."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description": "Located near Aurangabad, around 250 km from Pune, the Ajanta and Ellora Caves are UNESCO World Heritage Sites. Ajanta features Buddhist frescoes and sculptures from the 2nd century BC, while Ellora showcases Hindu, Buddhist, and Jain rock-cut temples. The Kailasa Temple at Ellora is a monolithic masterpiece. These caves are a window into India’s ancient art and architecture. They are ideal for history buffs and cultural travelers."
  }
],


"services": [
    {
        "name": "Innova per km rate for outstation",
        "description": "Get transparent and competitive per kilometer rates for Innova cabs for outstation travel. Ideal for long-distance journeys from Pune, our pricing ensures cost-effective travel without compromising on comfort or safety in our spacious 7-seater vehicles."
    },
    {
        "name": "Innova for outstation",
        "description": "Book a reliable Innova for outstation trips from Pune for family vacations, business travel, or weekend getaways. Our cabs come with professional drivers, clean interiors, ample luggage space, and flexible pickup options for a smooth journey."
    },
    {
        "name": "Innova Crysta Taxi Price per km",
        "description": "Check affordable per kilometer pricing for Innova Crysta taxis for outstation routes. Enjoy a luxurious and comfortable ride with premium interiors, powerful air-conditioning, and experienced drivers, all at a transparent per km fare."
    },
    {
        "name": "Outstation Innova Cabs",
        "description": "Hire premium Innova cabs for outstation trips from Pune. Whether it's a round trip or a one-way journey, our outstation service provides spacious vehicles, skilled drivers, and on-time service to make your travel seamless and stress-free."
    },
    {
        "name": "Innova Outstation Charges",
        "description": "Find detailed and transparent charges for Innova outstation bookings. Our rates include per km fare, driver allowance, tolls, and taxes where applicable, ensuring you have a clear cost estimate before you travel."
    },
    {
        "name": "Innova Crysta per km rate for outstation",
        "description": "Explore per km rates for booking Innova Crysta for outstation rides from Pune. Our Crysta cabs are perfect for long trips, offering comfort, space, and reliable service, all at competitive and transparent pricing structures."
    },
    {
        "name": "Hire Innova for outstation",
        "description": "Easily hire an Innova for your next outstation trip from Pune. Suitable for families, friends, or corporate groups, our 6 and 7-seater Innovas are available with expert drivers and flexible booking options for multi-day journeys."
    },
    {
        "name": "Innova Taxi for Outstation",
        "description": "Travel comfortably with our Innova taxi service for outstation trips from Pune. Our taxis are equipped with modern features, ample boot space, and reliable drivers who ensure timely arrivals and safe travel across states or cities."
    },
    {
        "name": "Innova for Outstation Trip",
        "description": "Plan your outstation trip from Pune with a trusted Innova cab. Whether it's a pilgrimage, leisure tour, or business travel, our Innova vehicles offer exceptional comfort, perfect for long-distance journeys with family or colleagues."
    },
    {
        "name": "Innova Outstation Cab Booking",
        "description": "Make hassle-free online bookings for Innova cabs for your outstation journey. With instant confirmations, flexible itineraries, and round-the-clock support, our booking system ensures a stress-free experience from start to finish."
    },
    {
        "name": "7 Seater Innova Outstation Rate",
        "description": "Get competitive rates for 7-seater Innova cabs for outstation travel. Ideal for large families or group tours, the Innova ensures ample space, smooth rides, and safety, all at affordable per km pricing."
    },
    {
        "name": "Toyota Innova Outstation Charges",
        "description": "View all-inclusive Toyota Innova outstation charges covering per km rates, driver fees, and applicable tolls. Our packages are designed to give you a clear cost breakdown with no hidden charges or last-minute surprises."
    },
    {
        "name": "Affordable Innova Outstation Taxi",
        "description": "Choose our affordable Innova outstation taxi services for budget-friendly travel from Pune. With experienced drivers, clean vehicles, and transparent pricing, we offer great value for families, groups, and corporate clients."
    },
    {
        "name": "Innova Round Trip Outstation",
        "description": "Book round trip Innova cab services for outstation travel from Pune. Our round-trip packages include competitive fares, professional drivers, and flexible return schedules for a convenient and enjoyable travel experience."
    }
],
"tableData": [
    ["Innova per km rate for outstation", "Innova for outstation"],
    ["Innova Crysta Taxi Price per km", "Outstation Innova Cabs"],
    ["Innova Outstation Charges", "Innova Crysta per km rate for outstation"],
    ["Hire Innova for outstation", "Innova Taxi for Outstation"],
    ["Innova for Outstation Trip", "Innova Outstation Cab Booking"],
    ["7 Seater Innova Outstation Rate", "Toyota Innova Outstation Charges"],
    ["Affordable Innova Outstation Taxi", "Innova Round Trip Outstation"]
],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Per Km Rate for Outstation Innova Cabs",
        "WhyChoosedescription": "Prince Cabs offers competitive per kilometer rates for outstation travel in spacious and comfortable Toyota Innova vehicles. Our pricing is transparent with no hidden charges—ideal for family trips, corporate travel, and long-distance journeys. Whether you're heading to Mumbai, Mahabaleshwar, Goa, or any destination from Pune, our per km rate model ensures you only pay for what you use."
    },
    {
        "WhyChooseheading": "Spacious & Comfortable Innova Vehicles",
        "WhyChoosedescription": "Our Innovas are well-maintained, air-conditioned, and come with plush seating and ample luggage space—perfect for group travel and long road trips. Whether you book a 6-seater or 7-seater variant, we ensure a smooth and comfortable experience for every passenger throughout the journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
        "WhyChoosedescription": "Each outstation Innova comes with a professional driver who has experience with highway driving and intercity routes. Our drivers ensure timely pickups, smooth navigation, and safe driving—letting you sit back and enjoy the road while we take care of the logistics."
    },
    {
        "WhyChooseheading": "Transparent Billing with Clear Per Km Charges",
        "WhyChoosedescription": "Our Innova outstation service includes a flat per km rate (e.g., ₹16–₹20/km depending on model and season) with full disclosure of driver allowance, tolls, and parking fees upfront. You get an itemized bill so you know exactly what you're paying for, with no surprise costs after the trip."
    },
    {
        "WhyChooseheading": "Flexible Packages for One-Way, Round-Trip & Multi-Day Tours",
        "WhyChoosedescription": "Choose from multiple outstation options like one-way drops, same-day returns, or multi-day packages for holiday tours. Whether it's a quick trip to Lonavala or a 4-day tour to Konkan, our team helps customize your booking as per your schedule and route."
    },
    {
        "WhyChooseheading": "Multiple Payment Options & Easy Booking",
        "WhyChoosedescription": "Book your Innova for outstation through our website, WhatsApp, or a quick phone call. We accept UPI, cards, net banking, and cash, ensuring a smooth and convenient payment process before or after your journey."
    },
    {
        "WhyChooseheading": "24/7 Support & Instant Booking Confirmation",
        "WhyChoosedescription": "Our customer service team is available round-the-clock to answer your queries, share fare estimates, and confirm your outstation booking. From the moment you book till your final drop, we ensure full support and hassle-free coordination."
    }
]























    }

const faqData = [
    {
        question: 'What is the per km rate for Innova cabs for outstation travel?',
        answer: 'Prince Cabs offers competitive per km rates for outstation trips. The standard Innova starts from ₹18/km, while the premium Innova Crysta is available from ₹20/km.',
    },
    {
        question: 'Are there any additional charges apart from the per km rate?',
        answer: 'Yes, additional charges may include tolls, parking, driver allowance (typically ₹300–₹500/day), and night halting if applicable. All charges are transparently shared upfront.',
    },
    {
        question: 'Is there a minimum distance requirement for outstation Innova bookings?',
        answer: 'Yes, the minimum billing is typically calculated on a 250 km/day basis for outstation trips, even if the distance traveled is less.',
    },
    {
        question: 'What’s the difference between Innova and Innova Crysta rates?',
        answer: 'Innova is a standard 6–7 seater SUV with basic features, while Innova Crysta offers more premium comfort. Crysta generally costs ₹2–₹3/km more than the standard Innova.',
    },
    {
        question: 'Can I choose between one-way and round-trip options for outstation Innova bookings?',
        answer: 'Absolutely! Prince Cabs offers flexible booking options—both one-way and round-trip. Charges will be adjusted accordingly based on your route and duration.',
    },
    {
        question: 'How can I get a quote for my outstation trip with Innova?',
        answer: 'You can get a quick quote by calling us or visiting our website. Just share your destination, travel dates, and preferred vehicle type, and we’ll provide the best rate.',
    },
    {
        question: 'Are your Innovas well-maintained and driver-experienced for long trips?',
        answer: 'Yes, all Innova vehicles are regularly serviced and driven by experienced professionals familiar with long-distance routes to ensure comfort and safety.',
    },
];

const testimonials = [
    {
        name: "Mr. Aditya More",
        position: "Business Traveler",
        text: "I booked an Innova Crysta for a Pune to Nashik trip. Very clean vehicle, fair pricing, and the per km rate was exactly as quoted. Great experience!",
        image: "/img/testimonial/testimonial-thumb-innova-1.png",
    },
    {
        name: "Mrs. Leena Patil",
        position: "Family Vacationer",
        text: "Our outstation journey from Pune to Mahabaleshwar in an Innova was smooth and comfortable. Prince Cabs gave us the best per km deal in the city.",
        image: "/img/testimonial/testimonial-thumb-innova-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Cab",
  "image": "https://princecab.com/assets/images/pune-outstation-cab.jpg",
  "description": "Book Pune to Outstation cab service with Prince Cabs. Reliable and affordable Innova, Swift Dzire, Etios, and family cabs available for round trips and tour packages. 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-outstation-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Outstation Cab | Affordable & Reliable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Outstation cab service with Innova, Swift Dzire, Etios, and family cabs. Affordable fares for round trips and tour packages. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Best Outstation Cab Service in Pune, Innova for Outstation, Pune to Outstation Innova Crysta, Outstation Cabs from Pune, Outstation Taxi Service Pune, Taxi Service in Pune for Outstation, Etios Cab for Outstation in Pune, Swift Dzire Outstation Taxi, Pune Outstation Affordable Cab, Pune Outstation Round Trip Taxi, Pune Outstation Tour Package, Pune Outstation Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovaperkmrateforoutstation;